__turbopack_context__.v({
  "folderZapTableRowTitle": "Table-module__J1GP0q__folderZapTableRowTitle",
  "hasFavoriteButton": "Table-module__J1GP0q__hasFavoriteButton",
  "hasShareButton": "Table-module__J1GP0q__hasShareButton",
  "iconButtonCell": "Table-module__J1GP0q__iconButtonCell",
  "kebabMenuWhiteSpace": "Table-module__J1GP0q__kebabMenuWhiteSpace",
  "lastModifiedColumn": "Table-module__J1GP0q__lastModifiedColumn",
  "ownerCell": "Table-module__J1GP0q__ownerCell",
  "titleCell": "Table-module__J1GP0q__titleCell",
  "trMenuOpen": "Table-module__J1GP0q__trMenuOpen",
});
